// components/WhatsAppSupportButton.jsx
import React from "react";
import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppSupportButton = () => {
  const whatsappNumber = "258842566731"; // <-- substitui pelo teu número sem "+"
  const defaultMessage = "Olá, preciso de ajuda com o Karingana.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <motion.a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.1 }}
      style={{
        position: "fixed",
        bottom: "100px",
        right: "25px",
        backgroundColor: "#25D366",
        color: "white",
        border: "none",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        fontSize: "1.8rem",
        boxShadow: "0px 4px 15px rgba(0,0,0,0.3)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        textDecoration: "none",
      }}
      aria-label="Suporte via WhatsApp"
    >
      <FaWhatsapp size={30} />
    </motion.a>
  );
};

export default WhatsAppSupportButton;
